import { takeLatest, call, put, select } from 'redux-saga/effects';
import { getPageContent } from 'yoda-interfaces/lib/Order/OrderApi';
import get from 'lodash/get';
import { getIRISSearchTerm } from '../helpers/Utils/ATCCommonUtils';
import {
    CARE_PLAN_WARRANTY_REQUEST,
    CARE_PLAN_WARRANTY_RESPONSE,
} from '../actionTypes/AddToCartInterstitialActionTypes';

function* CarePlanWarrantyRequestSaga(action) {
    const context = (state) => state.context;
    const appContext = yield select(context);
    const { enableCoreMediaContent = true } = appContext?.featureFlags || {};
    const carePlanWarrantyMap = yield select((state) =>
        get(state, 'context.preferences.carePlanWarrantyMap', {})
    );
    const { payload: { productType = '' } = {} } = action;
    if (action && action.payload) {
        // eslint-disable-next-line no-param-reassign
        delete action.payload.productType;
    }
    const irisSearchTerm = getIRISSearchTerm(productType, carePlanWarrantyMap);
    if (irisSearchTerm) {
        const contentPayload = { pageUrlOrSearchTerm: irisSearchTerm };
        if (enableCoreMediaContent) {
            contentPayload.isCMHeaderRequired = true;
        }
        let result = yield call(getPageContent, contentPayload);
        if (result.status === 200) {
            yield put({
                type: CARE_PLAN_WARRANTY_RESPONSE,
                response: result.status === 200 ? get(result, 'data.datas[0].data', '') : '',
            });
        } else if (enableCoreMediaContent && result.status !== 200) {
            contentPayload.isCMHeaderRequired = false;
            result = yield call(getPageContent, contentPayload);
            yield put({
                type: CARE_PLAN_WARRANTY_RESPONSE,
                response: result.status === 200 ? get(result, 'data.datas[0].data', '') : '',
            });
        }
    }
    yield put({ type: 'SHOW_GLOBAL_LOADER', payload: false });
}

const watchCarePlanWarrantySaga = function* watchCarePlanWarrantySaga() {
    yield takeLatest(CARE_PLAN_WARRANTY_REQUEST, CarePlanWarrantyRequestSaga);
};
watchCarePlanWarrantySaga.sagaName = 'watchCarePlanWarrantySaga';

export default watchCarePlanWarrantySaga;
